import { NgModule } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { MaterialModule } from '../material.module';

@NgModule({
	declarations: [],
	imports: [MaterialModule],
})
export class IconsModule {
	private path = '../../assets/icons';

	constructor(private domSanitizer: DomSanitizer, public matIconRegistry: MatIconRegistry) {
		this.matIconRegistry
			.addSvgIcon('building', this.setPath(`${this.path}/building.svg`))
			.addSvgIcon('co2', this.setPath(`${this.path}/co2.svg`))
			.addSvgIcon('coin-stack', this.setPath(`${this.path}/coin-stack.svg`))
			.addSvgIcon('humidity', this.setPath(`${this.path}/humidity.svg`))
			.addSvgIcon('lux', this.setPath(`${this.path}/lux.svg`))
			.addSvgIcon('meetings', this.setPath(`${this.path}/meetings.svg`))
			.addSvgIcon('motion', this.setPath(`${this.path}/motion.svg`))
			.addSvgIcon('nav-building', this.setPath(`${this.path}/nav-building.svg`))
			.addSvgIcon('nav-bullet', this.setPath(`${this.path}/nav-bullet.svg`))
			.addSvgIcon('nav-drop-down', this.setPath(`${this.path}/nav-drop-down.svg`))
			.addSvgIcon('nav-insights', this.setPath(`${this.path}/nav-insights.svg`))
			.addSvgIcon('nav-portfolio', this.setPath(`${this.path}/nav-portfolio.svg`))
			.addSvgIcon('nav-support', this.setPath(`${this.path}/nav-support.svg`))
			.addSvgIcon('sound', this.setPath(`${this.path}/sound.svg`))
			.addSvgIcon('temperature', this.setPath(`${this.path}/temperature.svg`))
			.addSvgIcon('top-bar-notification', this.setPath(`${this.path}/top-bar-notification.svg`))
			.addSvgIcon('top-bar-settings', this.setPath(`${this.path}/top-bar-settings.svg`))
			.addSvgIcon('utilization', this.setPath(`${this.path}/utilization.svg`));
	}
	private setPath(url: string): SafeResourceUrl {
		return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
	}
}
